import React from 'react';
import c from 'classnames';
import PlainButtonOrLink, {
  Props as PlainButtonOrLinkProps,
} from '../../Buttons/PlainButtonOrLink';
import s from './SophisticatedTooltipLink.scss';

interface Props extends PlainButtonOrLinkProps {}

const SophisticatedTooltipLink: React.FC<Props> = ({
  className,
  children,
  ...rest
}) => {
  return (
    <PlainButtonOrLink className={c(s['root'], className)} {...rest}>
      {children}
    </PlainButtonOrLink>
  );
};
SophisticatedTooltipLink.displayName = 'SophisticatedTooltipLink';

export default SophisticatedTooltipLink;
